import { FC, forwardRef } from 'react';
import { Theme } from '../types/enums';
import { FAIcon } from '../Icons/Icons';
import { TagStyle, TagWidth } from './types/enums';
import { TagPropsTypes, TagTheme } from './types/propsType';
import styles from './Tag.module.scss';

/**
 * @description This component provides badge or tag wrapped with style;
 * Props -> text (Required), theme ,icon and others.
 * Prop -> target dafault value is _self.
 */
const Tag: FC<TagPropsTypes> = forwardRef<HTMLSpanElement, TagPropsTypes>(
  ({ text, theme = Theme.BLACK, className, icon, tagWidth = TagWidth.FIT_CONTENT, style = TagStyle.SOLID, children = null }, ref) => (
    <span
      className={`${styles['base']} ${styles[style]} ${styles[theme]} ${styles[tagWidth]} ${className || ''}`}
      ref={ref}
    >
      {icon && <FAIcon {...icon} theme={theme} className={`${styles['icon']} ${styles['icon-left']}`} />}
      {text}
      {children}
    </span>
  ),
);

Tag.displayName = 'Tag';
export default Tag;
export { TagStyle, TagWidth };
export type { TagPropsTypes, TagTheme };
